import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const profileApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchProfiletDetails: builder.query({
      query: () => ({
        url: API_ENDPOINTS.PROFILE.PROFILE_DETAIL,
        method: "GET",
      }),
      providesTags: [{ type: "profileDetails", id: "LIST" }],
    }),

    postProfileImage: builder.mutation({
      query: (formdata) => ({
        url: API_ENDPOINTS.PROFILE.PROFILE_IMAGE,
        method: "POST",
        body: formdata,
      }),
      invalidatesTags: [{ type: "profileDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    postBannerImage: builder.mutation({
      query: (formdata) => ({
        url: API_ENDPOINTS.PROFILE.BANNER_IMAGE,
        method: "POST",
        body: formdata,
      }),
      invalidatesTags: [{ type: "profileDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    overallSubmit: builder.mutation({
      query: (formdata) => ({
        url: API_ENDPOINTS.PROFILE.PROFILE_SUBMIT,
        method: "POST",
        body: formdata,
      }),
      invalidatesTags: [{ type: "profileDetails", id: "LIST" }],
    }),

    //hr api

    hrFetchProfiletDetails: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.PROFILE.HR_PROFILE_DETAIL(empId),
        method: "GET",
      }),
      providesTags: [{ type: "hrProfileDetails", id: "LIST" }],
    }),
    hrPostProfileImage: builder.mutation({
      query: ({ empId, formdata }) => ({
        url: API_ENDPOINTS.PROFILE.HR_PROFILE_IMAGE(empId),
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "hrProfileDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    hrPostBannerImage: builder.mutation({
      query: ({ empId, formdata }) => ({
        url: API_ENDPOINTS.PROFILE.HR_BANNER_IMAGE(empId),
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "hrProfileDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
  }),
});

export const {
  usePostBannerImageMutation,
  usePostProfileImageMutation,
  useFetchProfiletDetailsQuery,
  useOverallSubmitMutation,
  useHrFetchProfiletDetailsQuery,
  useHrPostBannerImageMutation,
  useHrPostProfileImageMutation,
} = profileApi;
